import { KroButton } from "features/components/buttons/kroButton";

const GeneralDashboardItem = ({
  title,
  description,
  image,
  buttonText,
  onclick,
}: {
  title: string;
  description: string;
  image: string;
  buttonText: string;
  onclick: () => void;
}) => {
  return (
    <div className="scrollbar-hide min-w-[259px] rounded-[8px] border border-neutral-200 lg:w-[422px]">
      <img
        src={image}
        alt={title}
        className="h-94px] w-full rounded-t-[8px] lg:h-[168px]"
      />
      <div className="mt-4 flex flex-col gap-y-2 px-3">
        <p className="font-inter text-[16px] font-bold leading-[100%] tracking-[-0.5%] text-strong-950">
          {title}
        </p>
        <p className="font-inter text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700">
          {description}
        </p>
      </div>
      <div className="mb-3 mt-4 px-3">
        <KroButton
          iconSize={6}
          title={buttonText}
          onclick={onclick}
          className="h-9"
        />
      </div>
    </div>
  );
};

export default GeneralDashboardItem;
